/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AddUsersAndGroupsToHexMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  emails:
    | ReadonlyArray<Types.Scalars["String"]["input"]>
    | Types.Scalars["String"]["input"];
  groupIds:
    | ReadonlyArray<Types.Scalars["GroupId"]["input"]>
    | Types.Scalars["GroupId"]["input"];
  role: Types.ProjectRole;
  getSharedComponentCount?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type AddUsersAndGroupsToHexMutation = {
  readonly __typename: "Mutation";
  readonly createProjectGrantsForUsers: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly isShared: boolean;
    readonly logicViewIsShared: boolean;
    readonly org?: {
      readonly __typename: "Org";
      readonly id: c.OrgId;
      readonly sharedComponentCount: number;
    };
    readonly grants: ReadonlyArray<{
      readonly __typename: "ProjectGrant";
      readonly id: c.ProjectGrantId;
      readonly role: Types.ProjectRole;
      readonly holder:
        | { readonly __typename: "ApiClient" }
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
            readonly hexVersionViewerReason:
              | { readonly __typename: "Archived" }
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | { readonly __typename: "NonDraftVersion" }
              | { readonly __typename: "OAuthCollaborationNonSessionOwner" }
              | { readonly __typename: "OAuthCredsNotShared" }
              | { readonly __typename: "Trashed" }
              | null;
            readonly hexVersionAppUserReason:
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | null;
            readonly hexVersionDenialReason:
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingProjectRole";
                  readonly neededRoleV2: Types.ProjectRole;
                }
              | null;
          };
    }>;
  };
  readonly createProjectGrantsForGroups: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly isShared: boolean;
    readonly logicViewIsShared: boolean;
    readonly org?: {
      readonly __typename: "Org";
      readonly id: c.OrgId;
      readonly sharedComponentCount: number;
    };
    readonly grants: ReadonlyArray<{
      readonly __typename: "ProjectGrant";
      readonly id: c.ProjectGrantId;
      readonly role: Types.ProjectRole;
      readonly holder:
        | { readonly __typename: "ApiClient" }
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
            readonly hexVersionViewerReason:
              | { readonly __typename: "Archived" }
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | { readonly __typename: "NonDraftVersion" }
              | { readonly __typename: "OAuthCollaborationNonSessionOwner" }
              | { readonly __typename: "OAuthCredsNotShared" }
              | { readonly __typename: "Trashed" }
              | null;
            readonly hexVersionAppUserReason:
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | null;
            readonly hexVersionDenialReason:
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingProjectRole";
                  readonly neededRoleV2: Types.ProjectRole;
                }
              | null;
          };
    }>;
  };
};

export type UpdateProjectGrantMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  userId: Types.InputMaybe<Types.Scalars["UserId"]["input"]>;
  groupId: Types.InputMaybe<Types.Scalars["GroupId"]["input"]>;
  role: Types.ProjectRole;
}>;

export type UpdateProjectGrantMutation = {
  readonly __typename: "Mutation";
  readonly updateProjectGrant: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly logicViewIsShared: boolean;
    readonly grants: ReadonlyArray<{
      readonly __typename: "ProjectGrant";
      readonly id: c.ProjectGrantId;
      readonly role: Types.ProjectRole;
      readonly holder:
        | { readonly __typename: "ApiClient" }
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
            readonly hexVersionViewerReason:
              | { readonly __typename: "Archived" }
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | { readonly __typename: "NonDraftVersion" }
              | { readonly __typename: "OAuthCollaborationNonSessionOwner" }
              | { readonly __typename: "OAuthCredsNotShared" }
              | { readonly __typename: "Trashed" }
              | null;
            readonly hexVersionAppUserReason:
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | null;
            readonly hexVersionDenialReason:
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingProjectRole";
                  readonly neededRoleV2: Types.ProjectRole;
                }
              | null;
          };
    }>;
  };
};

export type RemoveHexPermissionMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  userId: Types.InputMaybe<Types.Scalars["UserId"]["input"]>;
  groupId: Types.InputMaybe<Types.Scalars["GroupId"]["input"]>;
  getSharedComponentCount?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type RemoveHexPermissionMutation = {
  readonly __typename: "Mutation";
  readonly removeHexPermission: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly isShared: boolean;
    readonly logicViewIsShared: boolean;
    readonly org?: {
      readonly __typename: "Org";
      readonly id: c.OrgId;
      readonly sharedComponentCount: number;
    };
    readonly grants: ReadonlyArray<{
      readonly __typename: "ProjectGrant";
      readonly id: c.ProjectGrantId;
      readonly role: Types.ProjectRole;
      readonly holder:
        | { readonly __typename: "ApiClient" }
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
            readonly hexVersionViewerReason:
              | { readonly __typename: "Archived" }
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | { readonly __typename: "NonDraftVersion" }
              | { readonly __typename: "OAuthCollaborationNonSessionOwner" }
              | { readonly __typename: "OAuthCredsNotShared" }
              | { readonly __typename: "Trashed" }
              | null;
            readonly hexVersionAppUserReason:
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | null;
            readonly hexVersionDenialReason:
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingProjectRole";
                  readonly neededRoleV2: Types.ProjectRole;
                }
              | null;
          };
    }>;
  };
};

export type RemoveSelfFromHexMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
}>;

export type RemoveSelfFromHexMutation = {
  readonly __typename: "Mutation";
  readonly removeSelfFromHex: string;
};

export type ShareHexWithSupportMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
}>;

export type ShareHexWithSupportMutation = {
  readonly __typename: "Mutation";
  readonly shareHexWithSupport: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly sharedWithSupport: boolean;
    readonly grants: ReadonlyArray<{
      readonly __typename: "ProjectGrant";
      readonly id: c.ProjectGrantId;
      readonly role: Types.ProjectRole;
      readonly holder:
        | { readonly __typename: "ApiClient" }
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
            readonly hexVersionViewerReason:
              | { readonly __typename: "Archived" }
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | { readonly __typename: "NonDraftVersion" }
              | { readonly __typename: "OAuthCollaborationNonSessionOwner" }
              | { readonly __typename: "OAuthCredsNotShared" }
              | { readonly __typename: "Trashed" }
              | null;
            readonly hexVersionAppUserReason:
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | null;
            readonly hexVersionDenialReason:
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingProjectRole";
                  readonly neededRoleV2: Types.ProjectRole;
                }
              | null;
          };
    }>;
  };
};

export type UnshareHexWithSupportMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
}>;

export type UnshareHexWithSupportMutation = {
  readonly __typename: "Mutation";
  readonly unshareHexWithSupport: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly sharedWithSupport: boolean;
    readonly grants: ReadonlyArray<{
      readonly __typename: "ProjectGrant";
      readonly id: c.ProjectGrantId;
      readonly role: Types.ProjectRole;
      readonly holder:
        | { readonly __typename: "ApiClient" }
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
            readonly hexVersionViewerReason:
              | { readonly __typename: "Archived" }
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | { readonly __typename: "NonDraftVersion" }
              | { readonly __typename: "OAuthCollaborationNonSessionOwner" }
              | { readonly __typename: "OAuthCredsNotShared" }
              | { readonly __typename: "Trashed" }
              | null;
            readonly hexVersionAppUserReason:
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | null;
            readonly hexVersionDenialReason:
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingProjectRole";
                  readonly neededRoleV2: Types.ProjectRole;
                }
              | null;
          };
    }>;
  };
};

export type AdminAddSelfToHexMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  reason: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type AdminAddSelfToHexMutation = {
  readonly __typename: "Mutation";
  readonly createProjectGrantForAdmin: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly sharedWithSupport: boolean;
    readonly grants: ReadonlyArray<{
      readonly __typename: "ProjectGrant";
      readonly id: c.ProjectGrantId;
      readonly role: Types.ProjectRole;
      readonly holder:
        | { readonly __typename: "ApiClient" }
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
            readonly hexVersionViewerReason:
              | { readonly __typename: "Archived" }
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | { readonly __typename: "NonDraftVersion" }
              | { readonly __typename: "OAuthCollaborationNonSessionOwner" }
              | { readonly __typename: "OAuthCredsNotShared" }
              | { readonly __typename: "Trashed" }
              | null;
            readonly hexVersionAppUserReason:
              | {
                  readonly __typename: "MissingOrgRole";
                  readonly neededOrgRole: Types.OrgRole;
                  readonly currentOrgRole: Types.OrgRole;
                }
              | { readonly __typename: "MissingProjectRole" }
              | null;
            readonly hexVersionDenialReason:
              | {
                  readonly __typename: "AssetAccess";
                  readonly hasAccessToSharedDataConnections: boolean;
                  readonly hasAccessToSharedPackages: boolean;
                  readonly hasAccessToSharedSecrets: boolean;
                  readonly hasAccessToSharedSyncRepositories: boolean;
                  readonly hasAccessToSharedFiles: boolean;
                  readonly secretsMissingAccess: ReadonlyArray<{
                    readonly __typename: "Secret";
                    readonly id: c.SecretId;
                    readonly name: c.SecretName;
                  }>;
                  readonly dataConnectionsMissingAccess: ReadonlyArray<{
                    readonly __typename: "DataConnection";
                    readonly id: c.DataConnectionId;
                    readonly connectionName: string;
                  }>;
                  readonly filesMissingAccess: ReadonlyArray<{
                    readonly __typename: "File";
                    readonly id: c.FileId;
                    readonly filename: string;
                  }>;
                  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                    readonly __typename: "SyncRepository";
                    readonly id: c.SyncRepositoryId;
                    readonly repoName: string;
                  }>;
                  readonly sharedPackagesMissingAccess: ReadonlyArray<{
                    readonly __typename: "VcsPackage";
                    readonly id: c.VcsPackageId;
                    readonly repoName: string;
                  }>;
                }
              | {
                  readonly __typename: "MissingProjectRole";
                  readonly neededRoleV2: Types.ProjectRole;
                }
              | null;
          };
    }>;
  };
};

export type UserPermissionFragment = {
  readonly __typename: "User";
  readonly name: string | null;
  readonly email: string;
  readonly active: boolean;
  readonly imageUrl: string | null;
  readonly orgRole: Types.OrgRole;
};

export type GroupPermissionFragment = {
  readonly __typename: "Group";
  readonly groupName: string;
};

export type PermissionListAssetAccessFragment = {
  readonly __typename: "AssetAccess";
  readonly hasAccessToSharedDataConnections: boolean;
  readonly hasAccessToSharedPackages: boolean;
  readonly hasAccessToSharedSecrets: boolean;
  readonly hasAccessToSharedSyncRepositories: boolean;
  readonly hasAccessToSharedFiles: boolean;
  readonly secretsMissingAccess: ReadonlyArray<{
    readonly __typename: "Secret";
    readonly id: c.SecretId;
    readonly name: c.SecretName;
  }>;
  readonly dataConnectionsMissingAccess: ReadonlyArray<{
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly connectionName: string;
  }>;
  readonly filesMissingAccess: ReadonlyArray<{
    readonly __typename: "File";
    readonly id: c.FileId;
    readonly filename: string;
  }>;
  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
    readonly __typename: "SyncRepository";
    readonly id: c.SyncRepositoryId;
    readonly repoName: string;
  }>;
  readonly sharedPackagesMissingAccess: ReadonlyArray<{
    readonly __typename: "VcsPackage";
    readonly id: c.VcsPackageId;
    readonly repoName: string;
  }>;
};

export type PermissionListViewerReasonFragment_Archived = {
  readonly __typename: "Archived";
};

export type PermissionListViewerReasonFragment_AssetAccess = {
  readonly __typename: "AssetAccess";
  readonly hasAccessToSharedDataConnections: boolean;
  readonly hasAccessToSharedPackages: boolean;
  readonly hasAccessToSharedSecrets: boolean;
  readonly hasAccessToSharedSyncRepositories: boolean;
  readonly hasAccessToSharedFiles: boolean;
  readonly secretsMissingAccess: ReadonlyArray<{
    readonly __typename: "Secret";
    readonly id: c.SecretId;
    readonly name: c.SecretName;
  }>;
  readonly dataConnectionsMissingAccess: ReadonlyArray<{
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly connectionName: string;
  }>;
  readonly filesMissingAccess: ReadonlyArray<{
    readonly __typename: "File";
    readonly id: c.FileId;
    readonly filename: string;
  }>;
  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
    readonly __typename: "SyncRepository";
    readonly id: c.SyncRepositoryId;
    readonly repoName: string;
  }>;
  readonly sharedPackagesMissingAccess: ReadonlyArray<{
    readonly __typename: "VcsPackage";
    readonly id: c.VcsPackageId;
    readonly repoName: string;
  }>;
};

export type PermissionListViewerReasonFragment_MissingOrgRole = {
  readonly __typename: "MissingOrgRole";
  readonly neededOrgRole: Types.OrgRole;
  readonly currentOrgRole: Types.OrgRole;
};

export type PermissionListViewerReasonFragment_MissingProjectRole = {
  readonly __typename: "MissingProjectRole";
};

export type PermissionListViewerReasonFragment_NonDraftVersion = {
  readonly __typename: "NonDraftVersion";
};

export type PermissionListViewerReasonFragment_OAuthCollaborationNonSessionOwner =
  { readonly __typename: "OAuthCollaborationNonSessionOwner" };

export type PermissionListViewerReasonFragment_OAuthCredsNotShared = {
  readonly __typename: "OAuthCredsNotShared";
};

export type PermissionListViewerReasonFragment_Trashed = {
  readonly __typename: "Trashed";
};

export type PermissionListViewerReasonFragment =
  | PermissionListViewerReasonFragment_Archived
  | PermissionListViewerReasonFragment_AssetAccess
  | PermissionListViewerReasonFragment_MissingOrgRole
  | PermissionListViewerReasonFragment_MissingProjectRole
  | PermissionListViewerReasonFragment_NonDraftVersion
  | PermissionListViewerReasonFragment_OAuthCollaborationNonSessionOwner
  | PermissionListViewerReasonFragment_OAuthCredsNotShared
  | PermissionListViewerReasonFragment_Trashed;

export type PermissionListAppUserReasonFragment_MissingOrgRole = {
  readonly __typename: "MissingOrgRole";
  readonly neededOrgRole: Types.OrgRole;
  readonly currentOrgRole: Types.OrgRole;
};

export type PermissionListAppUserReasonFragment_MissingProjectRole = {
  readonly __typename: "MissingProjectRole";
};

export type PermissionListAppUserReasonFragment =
  | PermissionListAppUserReasonFragment_MissingOrgRole
  | PermissionListAppUserReasonFragment_MissingProjectRole;

export type PermissionListDenialReasonFragment_AssetAccess = {
  readonly __typename: "AssetAccess";
  readonly hasAccessToSharedDataConnections: boolean;
  readonly hasAccessToSharedPackages: boolean;
  readonly hasAccessToSharedSecrets: boolean;
  readonly hasAccessToSharedSyncRepositories: boolean;
  readonly hasAccessToSharedFiles: boolean;
  readonly secretsMissingAccess: ReadonlyArray<{
    readonly __typename: "Secret";
    readonly id: c.SecretId;
    readonly name: c.SecretName;
  }>;
  readonly dataConnectionsMissingAccess: ReadonlyArray<{
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly connectionName: string;
  }>;
  readonly filesMissingAccess: ReadonlyArray<{
    readonly __typename: "File";
    readonly id: c.FileId;
    readonly filename: string;
  }>;
  readonly syncRepositoriesMissingAccess: ReadonlyArray<{
    readonly __typename: "SyncRepository";
    readonly id: c.SyncRepositoryId;
    readonly repoName: string;
  }>;
  readonly sharedPackagesMissingAccess: ReadonlyArray<{
    readonly __typename: "VcsPackage";
    readonly id: c.VcsPackageId;
    readonly repoName: string;
  }>;
};

export type PermissionListDenialReasonFragment_MissingProjectRole = {
  readonly __typename: "MissingProjectRole";
  readonly neededRoleV2: Types.ProjectRole;
};

export type PermissionListDenialReasonFragment =
  | PermissionListDenialReasonFragment_AssetAccess
  | PermissionListDenialReasonFragment_MissingProjectRole;

export type PermissionsListFragment = {
  readonly __typename: "ProjectGrant";
  readonly id: c.ProjectGrantId;
  readonly role: Types.ProjectRole;
  readonly holder:
    | { readonly __typename: "ApiClient" }
    | {
        readonly __typename: "Group";
        readonly groupId: c.GroupId;
        readonly groupName: string;
      }
    | {
        readonly __typename: "User";
        readonly name: string | null;
        readonly email: string;
        readonly active: boolean;
        readonly imageUrl: string | null;
        readonly orgRole: Types.OrgRole;
        readonly userId: c.UserId;
        readonly hexVersionViewerReason:
          | { readonly __typename: "Archived" }
          | {
              readonly __typename: "AssetAccess";
              readonly hasAccessToSharedDataConnections: boolean;
              readonly hasAccessToSharedPackages: boolean;
              readonly hasAccessToSharedSecrets: boolean;
              readonly hasAccessToSharedSyncRepositories: boolean;
              readonly hasAccessToSharedFiles: boolean;
              readonly secretsMissingAccess: ReadonlyArray<{
                readonly __typename: "Secret";
                readonly id: c.SecretId;
                readonly name: c.SecretName;
              }>;
              readonly dataConnectionsMissingAccess: ReadonlyArray<{
                readonly __typename: "DataConnection";
                readonly id: c.DataConnectionId;
                readonly connectionName: string;
              }>;
              readonly filesMissingAccess: ReadonlyArray<{
                readonly __typename: "File";
                readonly id: c.FileId;
                readonly filename: string;
              }>;
              readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                readonly __typename: "SyncRepository";
                readonly id: c.SyncRepositoryId;
                readonly repoName: string;
              }>;
              readonly sharedPackagesMissingAccess: ReadonlyArray<{
                readonly __typename: "VcsPackage";
                readonly id: c.VcsPackageId;
                readonly repoName: string;
              }>;
            }
          | {
              readonly __typename: "MissingOrgRole";
              readonly neededOrgRole: Types.OrgRole;
              readonly currentOrgRole: Types.OrgRole;
            }
          | { readonly __typename: "MissingProjectRole" }
          | { readonly __typename: "NonDraftVersion" }
          | { readonly __typename: "OAuthCollaborationNonSessionOwner" }
          | { readonly __typename: "OAuthCredsNotShared" }
          | { readonly __typename: "Trashed" }
          | null;
        readonly hexVersionAppUserReason:
          | {
              readonly __typename: "MissingOrgRole";
              readonly neededOrgRole: Types.OrgRole;
              readonly currentOrgRole: Types.OrgRole;
            }
          | { readonly __typename: "MissingProjectRole" }
          | null;
        readonly hexVersionDenialReason:
          | {
              readonly __typename: "AssetAccess";
              readonly hasAccessToSharedDataConnections: boolean;
              readonly hasAccessToSharedPackages: boolean;
              readonly hasAccessToSharedSecrets: boolean;
              readonly hasAccessToSharedSyncRepositories: boolean;
              readonly hasAccessToSharedFiles: boolean;
              readonly secretsMissingAccess: ReadonlyArray<{
                readonly __typename: "Secret";
                readonly id: c.SecretId;
                readonly name: c.SecretName;
              }>;
              readonly dataConnectionsMissingAccess: ReadonlyArray<{
                readonly __typename: "DataConnection";
                readonly id: c.DataConnectionId;
                readonly connectionName: string;
              }>;
              readonly filesMissingAccess: ReadonlyArray<{
                readonly __typename: "File";
                readonly id: c.FileId;
                readonly filename: string;
              }>;
              readonly syncRepositoriesMissingAccess: ReadonlyArray<{
                readonly __typename: "SyncRepository";
                readonly id: c.SyncRepositoryId;
                readonly repoName: string;
              }>;
              readonly sharedPackagesMissingAccess: ReadonlyArray<{
                readonly __typename: "VcsPackage";
                readonly id: c.VcsPackageId;
                readonly repoName: string;
              }>;
            }
          | {
              readonly __typename: "MissingProjectRole";
              readonly neededRoleV2: Types.ProjectRole;
            }
          | null;
      };
};

export const PermissionListAssetAccessFragmentDoc = /*#__PURE__*/ gql`
  fragment PermissionListAssetAccessFragment on AssetAccess {
    hasAccessToSharedDataConnections
    hasAccessToSharedPackages
    hasAccessToSharedSecrets
    hasAccessToSharedSyncRepositories
    hasAccessToSharedFiles
    secretsMissingAccess {
      id
      name
    }
    dataConnectionsMissingAccess {
      id
      connectionName
    }
    filesMissingAccess {
      id
      filename
    }
    syncRepositoriesMissingAccess {
      id
      repoName
    }
    sharedPackagesMissingAccess {
      id
      repoName
    }
  }
`;
export const PermissionListViewerReasonFragmentDoc = /*#__PURE__*/ gql`
  fragment PermissionListViewerReasonFragment on HexVersionViewerReason {
    ... on AssetAccess {
      ...PermissionListAssetAccessFragment
    }
    ... on MissingOrgRole {
      neededOrgRole
      currentOrgRole
    }
  }
  ${PermissionListAssetAccessFragmentDoc}
`;
export const PermissionListAppUserReasonFragmentDoc = /*#__PURE__*/ gql`
  fragment PermissionListAppUserReasonFragment on HexVersionAppUserReason {
    ... on MissingOrgRole {
      neededOrgRole
      currentOrgRole
    }
  }
`;
export const PermissionListDenialReasonFragmentDoc = /*#__PURE__*/ gql`
  fragment PermissionListDenialReasonFragment on HexVersionDenialReason {
    ... on AssetAccess {
      ...PermissionListAssetAccessFragment
    }
    ... on MissingProjectRole {
      neededRoleV2
    }
  }
  ${PermissionListAssetAccessFragmentDoc}
`;
export const UserPermissionFragmentDoc = /*#__PURE__*/ gql`
  fragment UserPermissionFragment on User {
    name
    email
    active
    imageUrl
    orgRole
  }
`;
export const GroupPermissionFragmentDoc = /*#__PURE__*/ gql`
  fragment GroupPermissionFragment on Group {
    groupName: name
  }
`;
export const PermissionsListFragmentDoc = /*#__PURE__*/ gql`
  fragment PermissionsListFragment on ProjectGrant {
    id
    role
    holder {
      ... on User {
        userId: id
        hexVersionViewerReason(hexVersionId: $hexVersionId) {
          ...PermissionListViewerReasonFragment
        }
        hexVersionAppUserReason(hexVersionId: $hexVersionId) {
          ...PermissionListAppUserReasonFragment
        }
        hexVersionDenialReason(hexVersionId: $hexVersionId) {
          ...PermissionListDenialReasonFragment
        }
        ...UserPermissionFragment
      }
      ... on Group {
        groupId: id
        ...GroupPermissionFragment
      }
    }
  }
  ${PermissionListViewerReasonFragmentDoc}
  ${PermissionListAppUserReasonFragmentDoc}
  ${PermissionListDenialReasonFragmentDoc}
  ${UserPermissionFragmentDoc}
  ${GroupPermissionFragmentDoc}
`;
export const AddUsersAndGroupsToHexDocument = /*#__PURE__*/ gql`
  mutation AddUsersAndGroupsToHex(
    $hexId: HexId!
    $hexVersionId: HexVersionId!
    $emails: [String!]!
    $groupIds: [GroupId!]!
    $role: ProjectRole!
    $getSharedComponentCount: Boolean = false
  ) {
    createProjectGrantsForUsers(
      emails: $emails
      hexId: $hexId
      role: $role
      createUsersIfNotExists: true
    ) {
      id
      isShared
      logicViewIsShared
      org @include(if: $getSharedComponentCount) {
        id
        sharedComponentCount
      }
      grants {
        ...PermissionsListFragment
      }
    }
    createProjectGrantsForGroups(
      hexId: $hexId
      groupIds: $groupIds
      role: $role
    ) {
      id
      isShared
      logicViewIsShared
      org @include(if: $getSharedComponentCount) {
        id
        sharedComponentCount
      }
      grants {
        ...PermissionsListFragment
      }
    }
  }
  ${PermissionsListFragmentDoc}
`;
export type AddUsersAndGroupsToHexMutationFn = Apollo.MutationFunction<
  AddUsersAndGroupsToHexMutation,
  AddUsersAndGroupsToHexMutationVariables
>;

/**
 * __useAddUsersAndGroupsToHexMutation__
 *
 * To run a mutation, you first call `useAddUsersAndGroupsToHexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUsersAndGroupsToHexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUsersAndGroupsToHexMutation, { data, loading, error }] = useAddUsersAndGroupsToHexMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      hexVersionId: // value for 'hexVersionId'
 *      emails: // value for 'emails'
 *      groupIds: // value for 'groupIds'
 *      role: // value for 'role'
 *      getSharedComponentCount: // value for 'getSharedComponentCount'
 *   },
 * });
 */
export function useAddUsersAndGroupsToHexMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddUsersAndGroupsToHexMutation,
    AddUsersAndGroupsToHexMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddUsersAndGroupsToHexMutation,
    AddUsersAndGroupsToHexMutationVariables
  >(AddUsersAndGroupsToHexDocument, options);
}
export type AddUsersAndGroupsToHexMutationHookResult = ReturnType<
  typeof useAddUsersAndGroupsToHexMutation
>;
export type AddUsersAndGroupsToHexMutationResult =
  Apollo.MutationResult<AddUsersAndGroupsToHexMutation>;
export type AddUsersAndGroupsToHexMutationOptions = Apollo.BaseMutationOptions<
  AddUsersAndGroupsToHexMutation,
  AddUsersAndGroupsToHexMutationVariables
>;
export const UpdateProjectGrantDocument = /*#__PURE__*/ gql`
  mutation UpdateProjectGrant(
    $hexId: HexId!
    $hexVersionId: HexVersionId!
    $userId: UserId
    $groupId: GroupId
    $role: ProjectRole!
  ) {
    updateProjectGrant(
      hexId: $hexId
      userId: $userId
      groupId: $groupId
      role: $role
    ) {
      id
      logicViewIsShared
      grants {
        ...PermissionsListFragment
      }
    }
  }
  ${PermissionsListFragmentDoc}
`;
export type UpdateProjectGrantMutationFn = Apollo.MutationFunction<
  UpdateProjectGrantMutation,
  UpdateProjectGrantMutationVariables
>;

/**
 * __useUpdateProjectGrantMutation__
 *
 * To run a mutation, you first call `useUpdateProjectGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectGrantMutation, { data, loading, error }] = useUpdateProjectGrantMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      hexVersionId: // value for 'hexVersionId'
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateProjectGrantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProjectGrantMutation,
    UpdateProjectGrantMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProjectGrantMutation,
    UpdateProjectGrantMutationVariables
  >(UpdateProjectGrantDocument, options);
}
export type UpdateProjectGrantMutationHookResult = ReturnType<
  typeof useUpdateProjectGrantMutation
>;
export type UpdateProjectGrantMutationResult =
  Apollo.MutationResult<UpdateProjectGrantMutation>;
export type UpdateProjectGrantMutationOptions = Apollo.BaseMutationOptions<
  UpdateProjectGrantMutation,
  UpdateProjectGrantMutationVariables
>;
export const RemoveHexPermissionDocument = /*#__PURE__*/ gql`
  mutation RemoveHexPermission(
    $hexId: HexId!
    $hexVersionId: HexVersionId!
    $userId: UserId
    $groupId: GroupId
    $getSharedComponentCount: Boolean = false
  ) {
    removeHexPermission(hexId: $hexId, userId: $userId, groupId: $groupId) {
      id
      isShared
      logicViewIsShared
      org @include(if: $getSharedComponentCount) {
        id
        sharedComponentCount
      }
      grants {
        ...PermissionsListFragment
      }
    }
  }
  ${PermissionsListFragmentDoc}
`;
export type RemoveHexPermissionMutationFn = Apollo.MutationFunction<
  RemoveHexPermissionMutation,
  RemoveHexPermissionMutationVariables
>;

/**
 * __useRemoveHexPermissionMutation__
 *
 * To run a mutation, you first call `useRemoveHexPermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHexPermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHexPermissionMutation, { data, loading, error }] = useRemoveHexPermissionMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      hexVersionId: // value for 'hexVersionId'
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *      getSharedComponentCount: // value for 'getSharedComponentCount'
 *   },
 * });
 */
export function useRemoveHexPermissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveHexPermissionMutation,
    RemoveHexPermissionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveHexPermissionMutation,
    RemoveHexPermissionMutationVariables
  >(RemoveHexPermissionDocument, options);
}
export type RemoveHexPermissionMutationHookResult = ReturnType<
  typeof useRemoveHexPermissionMutation
>;
export type RemoveHexPermissionMutationResult =
  Apollo.MutationResult<RemoveHexPermissionMutation>;
export type RemoveHexPermissionMutationOptions = Apollo.BaseMutationOptions<
  RemoveHexPermissionMutation,
  RemoveHexPermissionMutationVariables
>;
export const RemoveSelfFromHexDocument = /*#__PURE__*/ gql`
  mutation RemoveSelfFromHex($hexId: HexId!) {
    removeSelfFromHex(hexId: $hexId)
  }
`;
export type RemoveSelfFromHexMutationFn = Apollo.MutationFunction<
  RemoveSelfFromHexMutation,
  RemoveSelfFromHexMutationVariables
>;

/**
 * __useRemoveSelfFromHexMutation__
 *
 * To run a mutation, you first call `useRemoveSelfFromHexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSelfFromHexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSelfFromHexMutation, { data, loading, error }] = useRemoveSelfFromHexMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function useRemoveSelfFromHexMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveSelfFromHexMutation,
    RemoveSelfFromHexMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveSelfFromHexMutation,
    RemoveSelfFromHexMutationVariables
  >(RemoveSelfFromHexDocument, options);
}
export type RemoveSelfFromHexMutationHookResult = ReturnType<
  typeof useRemoveSelfFromHexMutation
>;
export type RemoveSelfFromHexMutationResult =
  Apollo.MutationResult<RemoveSelfFromHexMutation>;
export type RemoveSelfFromHexMutationOptions = Apollo.BaseMutationOptions<
  RemoveSelfFromHexMutation,
  RemoveSelfFromHexMutationVariables
>;
export const ShareHexWithSupportDocument = /*#__PURE__*/ gql`
  mutation ShareHexWithSupport($hexId: HexId!, $hexVersionId: HexVersionId!) {
    shareHexWithSupport(hexId: $hexId) {
      id
      sharedWithSupport
      grants {
        ...PermissionsListFragment
      }
    }
  }
  ${PermissionsListFragmentDoc}
`;
export type ShareHexWithSupportMutationFn = Apollo.MutationFunction<
  ShareHexWithSupportMutation,
  ShareHexWithSupportMutationVariables
>;

/**
 * __useShareHexWithSupportMutation__
 *
 * To run a mutation, you first call `useShareHexWithSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareHexWithSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareHexWithSupportMutation, { data, loading, error }] = useShareHexWithSupportMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      hexVersionId: // value for 'hexVersionId'
 *   },
 * });
 */
export function useShareHexWithSupportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ShareHexWithSupportMutation,
    ShareHexWithSupportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ShareHexWithSupportMutation,
    ShareHexWithSupportMutationVariables
  >(ShareHexWithSupportDocument, options);
}
export type ShareHexWithSupportMutationHookResult = ReturnType<
  typeof useShareHexWithSupportMutation
>;
export type ShareHexWithSupportMutationResult =
  Apollo.MutationResult<ShareHexWithSupportMutation>;
export type ShareHexWithSupportMutationOptions = Apollo.BaseMutationOptions<
  ShareHexWithSupportMutation,
  ShareHexWithSupportMutationVariables
>;
export const UnshareHexWithSupportDocument = /*#__PURE__*/ gql`
  mutation UnshareHexWithSupport($hexId: HexId!, $hexVersionId: HexVersionId!) {
    unshareHexWithSupport(hexId: $hexId) {
      id
      sharedWithSupport
      grants {
        ...PermissionsListFragment
      }
    }
  }
  ${PermissionsListFragmentDoc}
`;
export type UnshareHexWithSupportMutationFn = Apollo.MutationFunction<
  UnshareHexWithSupportMutation,
  UnshareHexWithSupportMutationVariables
>;

/**
 * __useUnshareHexWithSupportMutation__
 *
 * To run a mutation, you first call `useUnshareHexWithSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnshareHexWithSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unshareHexWithSupportMutation, { data, loading, error }] = useUnshareHexWithSupportMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      hexVersionId: // value for 'hexVersionId'
 *   },
 * });
 */
export function useUnshareHexWithSupportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnshareHexWithSupportMutation,
    UnshareHexWithSupportMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnshareHexWithSupportMutation,
    UnshareHexWithSupportMutationVariables
  >(UnshareHexWithSupportDocument, options);
}
export type UnshareHexWithSupportMutationHookResult = ReturnType<
  typeof useUnshareHexWithSupportMutation
>;
export type UnshareHexWithSupportMutationResult =
  Apollo.MutationResult<UnshareHexWithSupportMutation>;
export type UnshareHexWithSupportMutationOptions = Apollo.BaseMutationOptions<
  UnshareHexWithSupportMutation,
  UnshareHexWithSupportMutationVariables
>;
export const AdminAddSelfToHexDocument = /*#__PURE__*/ gql`
  mutation AdminAddSelfToHex(
    $hexId: HexId!
    $hexVersionId: HexVersionId!
    $reason: String
  ) {
    createProjectGrantForAdmin(hexId: $hexId, role: OWNER, reason: $reason) {
      id
      sharedWithSupport
      grants {
        ...PermissionsListFragment
      }
    }
  }
  ${PermissionsListFragmentDoc}
`;
export type AdminAddSelfToHexMutationFn = Apollo.MutationFunction<
  AdminAddSelfToHexMutation,
  AdminAddSelfToHexMutationVariables
>;

/**
 * __useAdminAddSelfToHexMutation__
 *
 * To run a mutation, you first call `useAdminAddSelfToHexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminAddSelfToHexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminAddSelfToHexMutation, { data, loading, error }] = useAdminAddSelfToHexMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      hexVersionId: // value for 'hexVersionId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useAdminAddSelfToHexMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminAddSelfToHexMutation,
    AdminAddSelfToHexMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminAddSelfToHexMutation,
    AdminAddSelfToHexMutationVariables
  >(AdminAddSelfToHexDocument, options);
}
export type AdminAddSelfToHexMutationHookResult = ReturnType<
  typeof useAdminAddSelfToHexMutation
>;
export type AdminAddSelfToHexMutationResult =
  Apollo.MutationResult<AdminAddSelfToHexMutation>;
export type AdminAddSelfToHexMutationOptions = Apollo.BaseMutationOptions<
  AdminAddSelfToHexMutation,
  AdminAddSelfToHexMutationVariables
>;
